<template>
  <el-form :rules="rules" :model="inputForm" ref="inputForm" id="formLogin" :action="urls.login" method="post">
    <el-form-item prop="mailAddress" :error="getErrorForField('mail_address', errors)"
      v-if="site === $siteType.site_admin" class="input-size-454">
      <el-input :placeholder="$t('mail_address')" v-model="inputForm.mailAddress" name="mail_address"
        @blur="trim('mailAddress')" />
    </el-form-item>
    <el-form-item prop="loginId" :error="getErrorForField('login_id', errors)" v-if="site === $siteType.site_partner"
      class="input-size-454">
      <el-input :placeholder="$t('login_id')" v-model="inputForm.loginId" name="login_id" @blur="trim('loginId')" />
    </el-form-item>
    <el-form-item prop="password" :error="getErrorForField('password', errors)" class="input-size-454">
      <el-input :placeholder="$t('password')" v-model="inputForm.password" name="password" type="password" />
    </el-form-item>
    <input type="hidden" name="_token" :value="csrf">
    <div class="form-footer">
      <el-button native-type="submit" class="btn-login" @click="login('inputForm')">{{ $t('login') }}</el-button>
    </div>
    <div class="btn-line-login" @click="goLine" v-if="site === $siteType.site_partner">
      <img class="btn-line-login__img" src="/images/icon_line.png" alt="">
      <div class="btn-line-login__divide"></div>
      <div class="btn-line-login__text">
        {{ $t('login_line_title') }}
      </div>
    </div>
  </el-form>
  <div class="mt-40">
    <div class="forgot-login-id" v-if="site === $siteType.site_partner">
      {{ $t('is_forgot_login_id') }}<el-link type="primary" :underline="false" @click="onClickFormResetLoginId">{{
        $t('is_here')
      }}</el-link>
    </div>
    <div class="forgot-password">
      {{ $t('is_forgot_password') }}<el-link type="primary" :underline="false" @click="onClickFormResetPassword">{{
        $t('is_here')
      }}</el-link>
    </div>
  </div>
  <reset-password v-if="isOpenFormResetPassword" :openFormReset="true" :urls="urls" :site="site"
    @is-close-popup-reset="handleClosePopupReset" @is-open-noti="handleOpenNoti">
  </reset-password>
  <form-forgot-login-id v-if="openFormForgotLoginId" :openFormForgotLoginId="true" :urls="urls" :site="site"
    @close-popup-forgot-login-id="handleClosePopupForgotLoginId" @is-open-noti="handleOpenNoti">
  </form-forgot-login-id>

  <noti-send-mail v-if="isOpenNotiSendMail" :openNotiSendMail="true" :site="site"
    @is-close-popup-noti="handleClosePopupNoti">
  </noti-send-mail>
</template>

<script>
export default {
  props: {
    urls: { type: Object, required: true, default: [] },
    errors: { type: Object, required: false },
    data: { type: Object, required: false },
    site: { type: Number, required: false }
  },
  components: ['reset-password', 'noti-send-mail'],
  data() {
    const rules = {
      mailAddress: [
        { required: true, message: this.$t('errors.required', [this.$t('mail_address')]), trigger: 'blur' },
        { type: "email", message: this.$t('errors.mail'), trigger: 'blur' }
      ],
      loginId: [
        { required: true, message: this.$t('errors.required', [this.$t('login_id')]), trigger: 'blur' },
      ],
      password: [
        { required: true, message: this.$t('errors.required', [this.$t('password')]), trigger: 'blur' },
      ]
    };

    return {
      inputForm: {
        mailAddress: "",
        password: "",
        loginId: ""
      },
      rules: rules,
      csrf: document.querySelector('meta[name="csrf-token"]').getAttribute('content'),
      isOpenFormResetPassword: false,
      isOpenNotiSendMail: false,
      openFormForgotLoginId: false
    }
  },

  methods: {
    login(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          const form = document.getElementById("formLogin");
          form.submit();
        } else {
          return false;
        }
      });
    },

    isErrorForField(field, errors) {
      return !(errors == null || errors.length == 0 || !errors.hasOwnProperty(field));
    },

    getErrorForField(field, errors) {
      return this.isErrorForField(field, errors) ? errors[field][0] : '';
    },

    onClickFormResetPassword() {
      this.isOpenFormResetPassword = true;
    },

    handleClosePopupReset() {
      this.isOpenFormResetPassword = false;
    },

    handleClosePopupNoti() {
      this.isOpenNotiSendMail = false;
    },

    handleOpenNoti() {
      this.isOpenNotiSendMail = true;
    },

    handleClosePopupForgotLoginId() {
      this.openFormForgotLoginId = false;
    },

    goLine() {
      window.open(this.$lineUrl + '?type=login', '_blank')
    },

    trim(field) {
      if (this.inputForm[field]) {
        this.inputForm[field] = this.inputForm[field].trim();
      }
    },

    onClickFormResetLoginId() {
      this.openFormForgotLoginId = true;
    }
  },
  created() {
    this.inputForm.mailAddress = this.data.oldMailAddress;
    this.inputForm.loginId = this.data.oldLoginId;
  },
}
</script>

<style lang="scss" scoped>
.btn-line-login {
  background: #06C755;
  width: 280px;
  height: 60px;
  border-radius: 16px;
  display: flex;
  justify-content: center;
  align-items: center;
  margin-left: auto;
  margin-right: auto;
  cursor: pointer;
  margin-top: 25px;

  .btn-line-login__img {
    width: 39px;
    height: 37px;
    object-fit: contain;
  }

  .btn-line-login__divide {
    height: 100%;
    width: 1px;
    background: rgb(0, 0, 0, 0.08);
    margin-left: 20px;
  }

  .btn-line-login__text {
    margin-left: 25px;
    font-size: 14px;
    color: #fff;
    letter-spacing: 1.4px;
    line-height: 31px;
  }
}
</style>
